import brand from '@helpers/brand';
import styled, { css } from 'styled-components';
import { NewIconTheme } from './NewIcon';

const Wrapper = styled.div<{ theme: NewIconTheme }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-family: 'Helvetica Neue LT W05_93 Blk E';
  text-transform: uppercase;
  padding: 4px;

  ${(props) => {
    switch (props.theme) {
      case 'redOnWhite':
        return css`
          background-color: ${brand.white};
          color: ${brand.red.base};
        `;
      case 'whiteOnRed':
        return css`
          background-color: ${brand.red.base};
          color: ${brand.white};
        `;
    }
  }}
`;

export const NewIconStyles = {
  Wrapper,
};
